/* global App */
const BaseRouter = require('./base')
const views = require('./views')

module.exports = BaseRouter.extend({
    initialize () {
        // User
        // Change email
        this.routings.push({
            key: 'accountConfirm',
            path: new RegExp(`${App.urlRegexTo('account/update-email')}.*$`),
            view: views.AccountCounterView,
        })

        this.routings.push({
            key: 'accountConfirm',
            path: new RegExp(`${App.urlRegexTo('user/account/confirm')}.*$`),
            view: views.AccountCounterView,
        })

        this.routings.push({
            key: 'accountUnsubscribe',
            path: new RegExp(`${App.urlRegexTo('user/account/unsubscribe-from-commercials')}.*$`),
            view: views.AccountCounterView,
        })

        this.routings.push({
            key: 'accountEdit',
            path: new RegExp(`${App.urlRegexTo('account/edit')}.*$`),
            view: views.AccountEditView,
        })

        this.routings.push({
            key: 'userPreferences',
            path: new RegExp(`${App.urlRegexTo('user-preferences/auto-deposit')}.*$`),
            view: views.UserPreferencesView,
        })

        this.routings.push({
            key: 'requestPasswordReset',
            path: new RegExp(`${App.urlRegexTo('account/request-password-reset')}.*$`),
            view: views.AccountRequestPasswordResetView,
        })
        this.routings.push({
            key: 'resetPassword',
            path: new RegExp(App.urlRegexTo('user/account/reset-password')),
            view: views.AccountResetPasswordView,
        })

        // Parking
        this.routings.push({
            key: 'parkingSearch',
            path: new RegExp(`${App.urlRegexTo('parking/list')}.*$`),
            view: views.EmptyView,
        })

        // Landing Merchant how it works
        this.routings.push({
            key: 'landingMerchantHowItWorks',
            path: new RegExp(`${App.urlRegexTo('site/landing-merchant-how-it-works')}.*$`),
            view: views.LandingMerchantHowItWorksView,
        })

        // Booking
        this.routings.push({
            key: 'booking',
            path: new RegExp(`${App.urlRegexTo('booking/show')}.*$`),
            view: views.BookingShowView,
        })

        this.routings.push({
            key: 'booking',
            path: new RegExp(`${App.urlRegexTo('booking/new')}.*$`),
            view: views.BookingShowView,
        })

        // Season Ticket Contract
        this.routings.push({
            key: 'seasonTicketContract',
            path: new RegExp(`${App.urlRegexTo('season-ticket-contract/show')}.*$`),
            view: views.SeasonTicketContractShowView,
        })

        this.routings.push({
            key: 'seasonTicketContract',
            path: new RegExp(`${App.urlRegexTo('season-ticket-contract/new')}.*$`),
            view: views.SeasonTicketContractShowView,
        })

        // Season Ticket
        this.routings.push({
            key: 'seasonTicket',
            path: new RegExp(`${App.urlRegexTo('season-ticket/contract')}.*$`),
            view: views.SeasonTicketContractView,
        })

        // OfferedParkingPass
        this.routings.push({
            key: 'passContract',
            path: new RegExp(`${App.urlRegexTo('offered-parking-pass/contract')}.*$`),
            view: views.OfferedParkingPassContractView,
        })

        this.routings.push({
            key: 'passNew',
            path: new RegExp(`${App.urlRegexTo('booked-parking-pass/new')}.*$`),
            view: views.BookedParkingPassListNew,
        })

        this.generateRoutes()
    },
})
